import { ChecklistID } from "./Checklist";
import { DealerLocationID } from "./DealerLocation";

export type BrandID = number;

export type BrandGroupID = number;

export interface Brand {
  created_on: string;
  updated_on: string;
  id: BrandID; // Identifier of the Brand
  name: string; // Name of the brand
  color: string; // Color of the brand in Claire
  logo: string; // Logo of the brand
  vin_prefix: string; // Prefix of the VIN for this brand
  brand_group_id: BrandGroupID; // Identifier of the brand group this brand belongs to
  button_label: string; // Label for the brand in Claire
  country: string; // Country of the brand
  is_active: boolean; // Indicates if the brand is active or not
  pon_brand_code: string; // Code in PON for this brand
  servicebox_wo: string; // Service box workorder url template
  servicebox_wo_2: string; // Second service box workorder url template
  servicebox_wo_2_name: string; // Name of the second service box workorder button
  servicebox_vin: string; // Service box vin url template
  tablet_service_button_url: string; // Url on the tablet to find service details about this brand
  dealer_location_id?: DealerLocationID;
  checklist_id?: ChecklistID;
  brand_group_name?: string; // Name of the brand group this brand belongs to
  brand_group?: BrandGroup; // Brand group this brand belongs to
}

export interface BrandGroup {
  id: BrandGroupID; // Identifier of the Brand Group
  name: string; // Name of the brand group
  color: string; // Color of the brand group in Claire
  logo: string; // Logo of the brand group
  button_label: string; // Label for the brand group in Claire
  country: string; // Country of the brand group
  is_active: boolean; // Indicates if the brand group is active or not
  servicebox_wo: string; // Service box workorder url template
  servicebox_wo_2: string; // Second service box workorder url template
  servicebox_wo_2_name: string; // Name of the second service box workorder button
  servicebox_vin: string; // Service box vin url template
  tablet_service_button_url: string; // Url on the tablet to find service details about this brand group
  brands?: Brand[]; // Brands belonging to this group
  dealer_location_id?: DealerLocationID; // Dealer Location Identifier
  checklist_id?: ChecklistID; // Checklist Identifier
}
